module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.object && _vm.object.hasPicture) ? _c('img', {
    staticClass: "img-circle profileImage",
    class: {
      user: _vm.object.kind == "user", group: _vm.object.kind == "group", private: _vm.object.kind == "group" && _vm.object.isPublic === false, public: _vm.object.kind == "group" && _vm.object.isPublic
    },
    attrs: {
      "src": _vm.object.picture,
      "title": _vm.object.name
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }) : (_vm.object && !_vm.object.hasPicture) ? _c('div', {
    staticClass: "profileImage ll",
    class: {
      user: _vm.object.kind == "user", group: _vm.object.kind == "group", private: _vm.object.kind == "group" && _vm.object.isPublic === false, public: _vm.object.kind == "group" && _vm.object.isPublic
    },
    style: ({
      backgroundColor: _vm.color()
    }),
    attrs: {
      "title": _vm.object.name
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("initials")(_vm.object.name)))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d280b54a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/VueObjectImg.vue
// module id = 901
// module chunks = 13